import { useEffect, useRef, useState } from "react";
import { isWeb, Modal, type ModalFooterProps } from "@medbillai/ui";
import { PICKER_TITLE, PlanSetupForm } from "./PlanSetupForm";
import type { PlanSetup } from "./usePlanSetup";
export function SetupSheet({
  setup
}: {
  setup: PlanSetup;
}) {
  const {
    open,
    start,
    opened
  } = setup.sheet;
  const [picking, setPicking] = useState(false);
  const [footer, setFooter] = useState<ModalFooterProps>();
  const wasSaving = useRef(false);
  useEffect(() => {
    if (wasSaving.current && !setup.saving && !setup.failed) {
      setup.setSheetOpen(false);
    }
    wasSaving.current = setup.saving;
  }, [setup.saving, setup.failed, setup.setSheetOpen]);
  return <Modal open={open} onOpenChange={setup.setSheetOpen} headerProps={{
    title: picking ? PICKER_TITLE : start === "profile" ? "Check your details" : "Add insurance",
    variant: "titleLeft",
    // A full-screen web dialog needs its close button.
    hideCloseButton: !isWeb
  }} surface="surface2" size="small" snapPoints={["auto"]} footerProps={setup.checking ? null : footer ?? null} data-sentry-element="Modal" data-sentry-component="SetupSheet" data-sentry-source-file="SetupSheet.tsx">
      <PlanSetupForm key={opened} setup={setup} start={start} inSheet onPickingChange={setPicking} pinFooter={setFooter} data-sentry-element="PlanSetupForm" data-sentry-source-file="SetupSheet.tsx" />
    </Modal>;
}